import { Navigate } from "react-router-dom";

import { isFeatureActiveByPartner } from "utils/getFeature";

interface IFeatureProps {
  name: string;
  partner: string;
  route?: boolean;
  children: JSX.Element;
}

const FeatureWrapperByPartner = ({ name, partner, route, children }: IFeatureProps) => {
  if (isFeatureActiveByPartner(name, partner)) {
    return children;
  }

  return route ? <Navigate to="/notfound" /> : null;
};

export default FeatureWrapperByPartner;
